import { render, staticRenderFns } from "./EditMultipositionSlot.vue?vue&type=template&id=12d3583d&scoped=true"
import script from "./EditMultipositionSlot.vue?vue&type=script&lang=ts"
export * from "./EditMultipositionSlot.vue?vue&type=script&lang=ts"
import style0 from "./EditMultipositionSlot.vue?vue&type=style&index=0&id=12d3583d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d3583d",
  null
  
)

export default component.exports